(function ($, window) {
    if ($('.product-detail.product-item').length > 0) {
        var singlePriceTextPrefix = '';

        function updatePrice(singlePrice, withoutSalesUnit) {
            var variantIdentifier = $('.product-detail.product-item').data('first-variation-identifier');
            if ($('.product-detail.product-item').find('.product-attributes select option').length > 0) {
                variantIdentifier = $('.product-detail.product-item').find('.product-attributes').find('select').val()
            }

            $.ajax({
                method: 'POST',
                url: window._AVENCY_BASE_actions.products.price,
                data: {
                    formatted: true,
                    variantIdentifier: variantIdentifier,
                    singlePrice: singlePrice === true,
                    withoutSalesUnit: withoutSalesUnit === true
                }
            })
                .done(function (data) {
                    data = JSON.parse(data);
                    if (withoutSalesUnit === true) {
                        $('#singleprice').attr('data-content', singlePriceTextPrefix + data.price);
                    } else {
                        $('#price').text(data.price);
                    }
                });
        }

        updatePrice(false, false);
        if ($('#singleprice').length > 0) {
            singlePriceTextPrefix = $('#singleprice').data('content');
            updatePrice(true, true);
        }

        $('.product-detail.product-item').on('change', '.product-attributes', function () {
            updatePrice(false, false);
            if ($('#singleprice').length > 0) {
                updatePrice(true, true);
            }
        });
    }
})(jQuery, window);
